import * as React from 'react';
import {useDispatch} from 'react-redux';
import * as reduxApi from 'src/utils/redux-api-v2';

import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {useApiQuery} from 'src/hooks/useApiQuery';


const GetCompletedInterviewData = ({
  stepCandidateId,
  children,
  loaderComponent,
}: {
  stepCandidateId: number;
  children: React.ReactNode;
  loaderComponent?: React.ReactNode;
}) => {
  const {data: completedInterviewData, isLoading: loading} = useApiQuery(
    `/api/interview-candidates/${stepCandidateId}`,
    {
      queryOptions: {
        queryKey: ['completed-interview-data', stepCandidateId],
      },
      apiOptions: {
        method: 'GET',
        options: {
          apiPath: '/trmapi',
        },
      },
    },
  );

  if (loading) {
    return loaderComponent ? loaderComponent : <CircularLoader />;
  }

  if (!completedInterviewData && !loading) {
    return null;
  }

  // @ts-expect-error - TS2349 - This expression is not callable. | TS2723 - Cannot invoke an object which is possibly 'null' or 'undefined'.
  return children(completedInterviewData);
};

export default GetCompletedInterviewData;
